













































































































































































import {BASE_URL, ENDPOINTS, MainApi, put} from '@/api/mainApi';
import Vue from 'vue';
import {RequestSession} from "@/interfaces/requestSession";
import {Donation} from "@/interfaces/donation/donation";
import InvoiceComponent from "@/components/invoice/InvoiceComponent.vue"
import {isDownloadInvoice, isInvoice, isPayLink, isDigitalPayment} from "@/classes/PaymentMethod";
import {Type} from "@/classes/DeliveryMethod";
import {stepV1, stepV2} from "@/enums/donationStepOrder";
import { DonationStepFlowVersion } from '@/enums/donationStepFlowVersion';
import StepperFlowMixin from '@/mixins/donationStepperFlowMixin';

export default Vue.extend({
  components: { InvoiceComponent },
  mixins: [StepperFlowMixin],
  props: {},
  data() {
    return {
      loading: false,
      error: false,
      showReceipt: false,
      showInvoice: false,
      loadingReceipt: false,
      loadingInvoice: false,
      loadingCertificate: false,
      printIframe: false,
      displayInvoice: false
    };
  },
  computed: {
    steps(): typeof stepV1 | typeof stepV2 {
      return this.donationStepFlowVersion == DonationStepFlowVersion.V1 ? stepV1 : stepV2;
    },
    requestSession(): RequestSession {
      return this.$store.state.requestSession
    },
    donation(): Donation {
      return this.$store.state.donation as Donation
    },
    serialnumber(): string {
      return this.donation ? this.donation.serialnumber.replace(/-/g, '') : '';
    },
    receiptSrc(): string {
      // TODO - rewrite endpoint url to something more statically typed
      return BASE_URL + '/api/donations/' + this.donation.serialnumber + '/receipt'
    },
    invoiceSrc(): string {
      return BASE_URL + "/" + MainApi + "/" + ENDPOINTS.INVOICE + "/" + ENDPOINTS.DOCUMENT + "?serialNumber=" + this.donation.serialnumber + "&asImage=" + false
    },
    isDownloadInvoice(): boolean {
      return this.donation.paymentSpecification != null && isDownloadInvoice(this.donation.paymentSpecification.paymentMethod.type);
    },
    isInvoice(): boolean {
      return this.donation.paymentSpecification != null && isInvoice(this.donation.paymentSpecification.paymentMethod.type);
    },
    isDigitalPayment(): boolean {
      return this.donation.paymentSpecification != null && isDigitalPayment(this.donation.paymentSpecification.paymentMethod.type);
    },
    isPaylink(): boolean {
      return this.donation.paymentSpecification != null && isPayLink(this.donation.paymentSpecification.paymentMethod.type);
    },
    isPaid(): boolean {
      return this.donation && this.donation.paymentSpecification && this.donation.paymentSpecification.paid;
    },
    deliveryIsPrint(): boolean { // used for egen formedling
      return this.donation.paymentSpecification != null && this.donation.deliveryMethod && this.donation.deliveryMethod.type === Type.PRINT
    },
    currentStep() {
      return this.$store.state.currentStep
    },
  },
  watch: {
    currentStep: {
      handler(newVal, oldVal) {
        if (newVal === this.steps.SUCCESS) {
          if(this.isInvoice)
          {
            this.displayInvoice = true;
          }
        }
      },
    }
  },
  methods: {
    toggleReceipt(): void {
      this.showReceipt = !this.showReceipt;
    },
    toggleInvoice(): void {
      this.showInvoice = !this.showInvoice;
    },
    reset() {
      this.$emit('reset');
    },
    isInvoicePayment()
    {
      return this.donation.paymentSpecification != null && isInvoice(this.donation.paymentSpecification.paymentMethod.type);
    },
    printPdf(): void {

      let iframe: HTMLIFrameElement = this.$refs.printIframe;

      if (iframe && iframe.contentWindow) {
        iframe.focus();
        iframe.contentWindow.print();
      }
    },
    getDonationCertificateUrl(): string {
      return BASE_URL + "/" + MainApi + "/" + ENDPOINTS.DONATIONS + '/' + this.donation.serialnumber + '/' + ENDPOINTS.CERTIFICATE
    },
    printCertificate(): void {
      this.loadingCertificate = true
      put(ENDPOINTS.PRINT + "/" + ENDPOINTS.DONATIONS + "/" + this.donation.serialnumber, {externalEntityId: this.donation.intermediary.externalSource.externalEntityId})
        .then((data: any) => {
          if (window != null) {
            let win: Window | null = window.open(this.getDonationCertificateUrl() + "?includeAddress=false&log=true", '_blank');
            if (win) {
              win.focus();
            }
          }
        }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.loadingCertificate = false
      })
    }
  },
});
